import { IconButton } from '@material-ui/core';
import { useState } from 'react';
import { FieldValues } from 'react-hook-form';

import { Icon } from '@/components/shared/components/Icon';
import { TextFormFieldProps } from '@/components/shared/components/NewContextForms/TextFormField';

import { TextFormField } from '../TextFormField';

export function PasswordFormField<TFieldValues extends FieldValues>({
  name,
  ...props
}: TextFormFieldProps<TFieldValues>) {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  let endAdornment = props?.InputProps?.endAdornment;

  if (!endAdornment) {
    endAdornment = (
      <IconButton
        aria-label="toggle password visibility"
        onClick={() => setShowPassword(!showPassword)}
        edge="end"
        style={{ padding: '6px', marginRight: '8px' }}
      >
        <Icon size={24} style={{ verticalAlign: 'text-top' }}>
          {showPassword ? 'visibility_off' : 'visibility'}
        </Icon>
      </IconButton>
    );
  }

  return (
    <TextFormField
      name={name}
      {...props}
      InputProps={{
        ...props?.InputProps,
        endAdornment,
      }}
      type={showPassword ? 'text' : 'password'}
    />
  );
}
